import { render, staticRenderFns } from "./programPage.vue?vue&type=template&id=f8dd8108&scoped=true&"
import script from "./programPage.vue?vue&type=script&lang=js&"
export * from "./programPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dd8108",
  null
  
)

export default component.exports